'use es6';

import * as DSAssetFamilies from 'customer-data-filters/filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import createDSAdapter from './createDSAdapter';
import http from 'hub-http/clients/apiClient';
import { Map as ImmutableMap, Record } from 'immutable';
import { isUnifiedEventObjectTypeId } from '../../../filterQueryFormat/ObjectTypeId';
import { AdapterCache } from '../requestCaches/adaptersCache';
import { getFrameworkBuilderMetaDataValue } from '../../../utilities/frameworkBuilder';
import { CONTACT_TYPE_ID } from '../../../data/objectTypeIds';
const UPDATER_CACHE_KEY = 'FRAMEWORK_BUILDER_TYPES_METADATA';
export const fetchedDataCache = new AdapterCache();
export const processedDataCache = new AdapterCache();
export const FrameworkBuilderTypeMetadataRecord = Record({
  categoryGroupLabel: undefined,
  categoryGroupName: undefined,
  fullyQualifiedName: undefined,
  gates: [],
  label: undefined,
  objectTypeId: undefined,
  scopes: []
});
export function makeUnifiedEventsAdapter() {
  function isAssetFamilySupported(assetFamily) {
    return assetFamily === DSAssetFamilies.UNIFIED_EVENT;
  }
  function getFetcherFromProps() {
    return http.get;
  }
  function fetch(httpClient) {
    const url = 'framework-builder/v1/read/metadata/types/filtersFrontEnd';
    const cached = fetchedDataCache.get(url);
    if (cached) {
      return cached;
    }
    const request = httpClient(url);
    fetchedDataCache.set(url, request);
    return request;
  }
  function updater(unifiedEvents) {
    const cached = processedDataCache.get(UPDATER_CACHE_KEY);
    if (cached) {
      return cached;
    }
    const formatted = Object.entries(unifiedEvents).reduce((acc, [key, value]) => {
      const objectTypeId = getFrameworkBuilderMetaDataValue('objectTypeId', value.metadata);
      if (isUnifiedEventObjectTypeId(objectTypeId)) {
        const categoryGroupLabel = getFrameworkBuilderMetaDataValue('categoryGroupLabel', value.metadata);
        const categoryGroupName = getFrameworkBuilderMetaDataValue('categoryGroupName', value.metadata);
        const fullyQualifiedName = key;
        const gates = getFrameworkBuilderMetaDataValue('gates', value.metadata) || [];
        const label = getFrameworkBuilderMetaDataValue('singularForm', value.metadata) || key;
        const scopes = getFrameworkBuilderMetaDataValue('scopes', value.metadata) || [];
        const requiredObjectTypeIds = getFrameworkBuilderMetaDataValue('requiredObjectTypeIds', value.metadata) || [];
        // In customer-data-filters-ui we are supporting Unified Events only
        // for all object types using the requiredObjectTypeIds metadata field.
        // For here, we are only interested in supporting Unified Events for Contacts.
        // So we are filtering out all events types that are not compatible Contacts.
        if (requiredObjectTypeIds.length && !requiredObjectTypeIds.includes(CONTACT_TYPE_ID)) {
          return acc;
        }
        return acc.set(objectTypeId, FrameworkBuilderTypeMetadataRecord({
          categoryGroupLabel,
          categoryGroupName,
          fullyQualifiedName,
          gates,
          label,
          scopes,
          objectTypeId
        }));
      }
      return acc;
    }, ImmutableMap());
    processedDataCache.set(UPDATER_CACHE_KEY, formatted);
    return formatted;
  }
  return createDSAdapter({
    fetch,
    getFetcherFromProps,
    isAssetFamilySupported,
    updater
  });
}
const unifiedEventAdapter = makeUnifiedEventsAdapter();
export default unifiedEventAdapter;